<!--  -->
<template>
  <div class="Team">
    <h1>{{ title }}</h1>
    <div class="team-member">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="(item, index) in teamList" :key="index">
          <router-link to="/ourteam">
            <h2>{{ item.name }}</h2>
            <h3>{{ item.position }}</h3>
            <div class="msg" v-html="item.msg"></div>
          </router-link>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      title: "", //管理团队
      teamList: [
        /* 
        {
          name: "李晓峰",
          position: "董事会主席兼首席执行官",
          msg: "公司董事会主席兼首席执行官。自二零零六年七月十四日起一直担任董事，并自二零零八年四月至二零一零年七月期间担任本公司首席执行官及自二零一二年九月二十日起重新担任本公司首席执行官。现时也在本集团多个附属公司担任董事。在医疗器械行业拥有逾28年的经验，现时担任上海理工大学医疗器械学院教授。自一九九六年至一九九七年期间担任总部位于美国加利福尼亚州的纳斯达克上市医疗器械公司 Endocare Inc. 的研发副总裁。自一九九零年至一九九五年，彼于美国马里兰州一家医疗器械公司Cryomedical Sciences Inc. （被第三方收购前该公司曾在纳斯达克上市）担任高级工程师、首席科学家、研发部主任兼工程部副总裁等职务。分别于一九八三年及一九八五年自上海理工大学获得制冷工程学士学位及低温工程硕士学位。于一九九二年自纽约州立大学宾汉姆顿分校获得生物科学博士学位。",
        },
        {
          name: "李晓峰",
          position: "董事会主席兼首席执行官",
          msg: "公司董事会主席兼首席执行官。自二零零六年七月十四日起一直担任董事，并自二零零八年四月至二零一零年七月期间担任本公司首席执行官及自二零一二年九月二十日起重新担任本公司首席执行官。现时也在本集团多个附属公司担任董事。在医疗器械行业拥有逾28年的经验，现时担任上海理工大学医疗器械学院教授。自一九九六年至一九九七年期间担任总部位于美国加利福尼亚州的纳斯达克上市医疗器械公司 Endocare Inc. 的研发副总裁。自一九九零年至一九九五年，彼于美国马里兰州一家医疗器械公司Cryomedical Sciences Inc. （被第三方收购前该公司曾在纳斯达克上市）担任高级工程师、首席科学家、研发部主任兼工程部副总裁等职务。分别于一九八三年及一九八五年自上海理工大学获得制冷工程学士学位及低温工程硕士学位。于一九九二年自纽约州立大学宾汉姆顿分校获得生物科学博士学位。",
        },
        {
          name: "李晓峰",
          position: "董事会主席兼首席执行官",
          msg: "公司董事会主席兼首席执行官。自二零零六年七月十四日起一直担任董事，并自二零零八年四月至二零一零年七月期间担任本公司首席执行官及自二零一二年九月二十日起重新担任本公司首席执行官。现时也在本集团多个附属公司担任董事。在医疗器械行业拥有逾28年的经验，现时担任上海理工大学医疗器械学院教授。自一九九六年至一九九七年期间担任总部位于美国加利福尼亚州的纳斯达克上市医疗器械公司 Endocare Inc. 的研发副总裁。自一九九零年至一九九五年，彼于美国马里兰州一家医疗器械公司Cryomedical Sciences Inc. （被第三方收购前该公司曾在纳斯达克上市）担任高级工程师、首席科学家、研发部主任兼工程部副总裁等职务。分别于一九八三年及一九八五年自上海理工大学获得制冷工程学士学位及低温工程硕士学位。于一九九二年自纽约州立大学宾汉姆顿分校获得生物科学博士学位。",
        },
       */
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //1.文章列表
    get_data() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 10,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.title = obj.yj_name;
            $.each(obj.data, function (i, k) {
              that.teamList.push({
                name: k.title,
                position: k.sign,
                msg: k.msg,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_data();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.Team {
  width: 100%;
  padding: 90px 0 0;
  h1 {
    font-size: 1.4rem;
    color: #193895;
    text-align: center;
  }
  .team-member {
    width: 1250px;
    margin: 70px auto 0;
    .el-carousel__item {
      padding: 0 100px;
      h2 {
        display: inline-block;
        font-size: 1.2rem;
        color: #333;
      }
      h3 {
        display: inline-block;
        font-size: 0.8rem;
        color: #969696;
      }
      .msg {
        margin-top: 30px;
        font-size: 1rem;
        color: #666;
      }
    }
  }
  .team-member >>> .el-carousel__arrow {
    width: 45px;
    height: 45px;
    background: #000000;
    opacity: 0.1;
  }
  .team-member >>> .el-carousel__arrow--left {
    left: 0px;
  }
  .team-member >>> .el-carousel__arrow--right {
    right: 0px;
  }
  .team-member >>> .el-carousel__arrow:hover {
    opacity: 0.5;
  }
}
@media screen and (max-width: $main-width) {
  .Team {
    .team-member {
      width: 100%;
      margin: 40px auto 0;
      .el-carousel__item {
        padding: 0 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/about/AboutTeam.vue